import { UNGROUPED_RESOURCES_GROUP_ID } from '@/console/features/groups/components/group-list/group-list.constants';

import { api } from '../../_generated/api/assets-api.generated';

const enhancedGatewaysApi = api.enhanceEndpoints({
  addTagTypes: ['Gateway', 'Groups', 'GatewayConfig', 'GlueLog'],
  endpoints: {
    ReadAllGateways: {
      providesTags: (_, __, args) => {
        const tags = [{ type: 'Gateway' as const, id: 'LIST' }];
        const filteredGroup = args?.filter?.groupId;
        const groupId = filteredGroup?.contains ?? UNGROUPED_RESOURCES_GROUP_ID;
        if (filteredGroup) {
          return [...tags, { type: 'Groups' as const, id: groupId }];
        }
        return tags;
      },
    },
    ReadGatewaysForList: {
      providesTags: (_, __, args) => {
        const tags = [{ type: 'Gateway' as const, id: 'LIST' }];
        const filteredGroup = args?.filter?.groupId;
        const groupId = filteredGroup?.contains ?? UNGROUPED_RESOURCES_GROUP_ID;
        if (filteredGroup) {
          return [...tags, { type: 'Groups' as const, id: groupId }];
        }
        return tags;
      },
    },
    CreateGateway: {
      invalidatesTags: [
        { type: 'Gateway' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    ReadGateway: {
      providesTags: (_, __, arg) => {
        return [{ type: 'Gateway' as const, id: arg.gatewayId }];
      },
    },
    ReadGatewayHealthStatus: {
      providesTags: (_, __, arg) => {
        return [{ type: 'Gateway' as const, id: arg.gatewayId }];
      },
    },
    ReadGatewayVersionsByIds: {
      providesTags: (_, __, arg) => {
        const ids = Array.isArray(arg.gatewayIds)
          ? arg.gatewayIds
          : [arg.gatewayIds];
        return ids.map((id) => ({ type: 'Gateway' as const, id }));
      },
    },
    ReadGatewaysHealthStatus: {
      providesTags: (_, __, arg) => {
        const ids = Array.isArray(arg.gatewayIds)
          ? arg.gatewayIds
          : [arg.gatewayIds];
        return ids.map((id) => ({ type: 'Gateway' as const, id }));
      },
    },
    UpdateGateway: {
      invalidatesTags: (result, _, arg) => [
        { type: 'Gateway' as const, id: arg.gatewayId },
        { type: 'Gateway' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    DeleteGateway: {
      invalidatesTags: [
        { type: 'Gateway' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    ReadLinkedDevicesForGateway: {
      providesTags: (_, __, arg) => {
        return [{ type: 'Gateway' as const, id: arg.gatewayId }];
      },
    },
    UpdateGatewayConfig: {
      invalidatesTags: (_, __, arg) => {
        return [
          { type: 'Gateway' as const, id: arg.gatewayId },
          { type: 'GatewayConfig' as const, id: arg.gatewayId },
        ];
      },
    },
    ReadGatewayConfig: {
      providesTags: (_, __, arg) => {
        return [{ type: 'GatewayConfig' as const, id: arg.gatewayId }];
      },
    },
    ReadGatewayGlueLogEntries: {
      providesTags: (_, __, arg) => {
        return [{ type: 'GlueLog' as const, id: arg.gatewayId }];
      },
    },
  },
});

export const gatewaysApi = enhancedGatewaysApi;

export const {
  useDeleteGatewayMutation,
  useReadAllGatewaysQuery,
  useReadGatewaysForListQuery,
  useCreateGatewayMutation,
  useUpdateGatewayMutation,
  useReadLinkedDevicesForGatewayQuery,
  useReadDevicesSyncStatusByGatewayQuery,
  useReadGatewaysByIdsQuery,
  useReadGatewayQuery,
  useReadGatewayHealthStatusQuery,
  useLazyReadGatewayHealthStatusQuery,
  useReadGatewaysHealthStatusQuery,
  useReadGatewayVersionsByIdsQuery,
  useLazyReadDeviceConnectivityStatusQuery,
  useReadGatewayNamesForRoleRowQuery,
  useReadGatewayConfigQuery,
  useReadGatewayUpdateStatusQuery,
  useRequestGatewayUpdateMutation,
  useReadGatewaySetupQuery,
  useReadGatewayGlueLogEntriesQuery,
  useLazyReadGatewayGlueLogEntriesQuery,
} = gatewaysApi;
